import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, CheckCircle, Mail } from 'lucide-react'
import { authApi } from '../../lib/api/auth'
import './auth.css'

export default function ForgotPassword() {
  const [email, setEmail]       = useState('')
  const [loading, setLoading]   = useState(false)
  const [error, setError]       = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await authApi.forgotPassword(email)
      setSubmitted(true)
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Something went wrong. Please try again.'
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="forgot-page">
      <div className="forgot-wrapper">

        {!submitted ? (
          <div className="forgot-card">
            <Link to="/signin" className="forgot-back">
              <ArrowLeft size={18} />
              Back to Sign In
            </Link>

            <div className="forgot-logo-wrap">
              <img src="/InterviewDressRehearsal_LOGO.png" alt="IDR" className="forgot-logo" />
            </div>

            <div className="auth-header" style={{ textAlign: 'center' }}>
              <h2>Reset your password</h2>
              <p>Enter your email and we'll send you a reset link</p>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                {loading ? 'Sending…' : <><Mail size={18} /> Send Reset Link</>}
              </button>
            </form>
          </div>
        ) : (
          <div className="forgot-card forgot-success">
            <div className="forgot-success-icon">
              <CheckCircle size={48} color="#48bb78" />
            </div>
            <h2>Check your email</h2>
            <p>We've sent a password reset link to <strong>{email}</strong></p>
            <p className="forgot-hint">Didn't receive it? Check your spam folder or try again in a few minutes.</p>
            <Link to="/signin" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}>
              Back to Sign In
            </Link>
          </div>
        )}

      </div>

    </div>
  )
}
